const horizontalThickness = 54;
const verticalThickness = 162;

function legend (_val) { 
  if (!arguments.length) return this.__attrs__.legend;
  if (_val === true) this.__attrs__.legend = {orient: 'bottom', thickness: horizontalThickness  }
  else if (_val === false) this.__attrs__.legend = null;
  else if (typeof _val === 'object') {
    if(!_val.orient) _val.orient = 'bottom';
    if(!_val.thickness) _val.thickness = (_val.orient === 'bottom' || _val.orient === 'top') ? horizontalThickness : verticalThickness;
    this.__attrs__.legend = _val;
  }
  return this;
}

export default legend;


// WEBPACK FOOTER //
// ./layouts/default/legend.js